import React from "react";
import "./Frame117.css";
import { Link } from "react-router-dom";

function Frame117(props) {
  const { className } = props;

  return (
    <div className={`frame-117-2 ${className || ""}`}>
      <Link to="/functional-view-1">
        <div className="functional-view valign-text-middle inter-medium-white-18px">Functional View</div>
      </Link>
    </div>
  );
}

export default Frame117;
